import React, { useState, useRef, useEffect } from 'react';
import { Palette, Moon, Sun, Leaf, Flame } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from '../ui/Button';

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        menuRef.current &&
        buttonRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const themes = [
    { id: 'dark', name: 'Dark', icon: Moon },
    { id: 'bluish', name: 'Bluish', icon: Sun },
    { id: 'greenchy', name: 'Greenchy', icon: Leaf },
    { id: 'orangy', name: 'Orangy', icon: Flame },
  ] as const;

  return (
    <div className="relative">
      <Button
        ref={buttonRef}
        variant="secondary"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        className="!p-2"
      >
        <Palette className="h-4 w-4" />
      </Button>

      {isOpen && (
        <div
          ref={menuRef}
          className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-50"
        >
          <div className="py-1">
            {themes.map(({ id, name, icon: Icon }) => (
              <button
                key={id}
                onClick={() => {
                  setTheme(id as any);
                  setIsOpen(false);
                }}
                className={`
                  w-full px-4 py-2 text-sm flex items-center gap-2
                  ${theme === id 
                    ? 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white' 
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                  }
                `}
              >
                <Icon className="h-4 w-4" />
                {name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}